import { DIALOGS_MAP_KEYS, DialogsMapKeyType } from './_dialogs-map';
import {
  DialogsCurrentMembershipType,
  DialogsMembershipPermissionsKeysType,
  DialogsMembershipPermissionsType,
} from './_dialogs-permissions-query';
import {
  BuildDialogUrlPropValue,
  DIALOG_BOOLEAN_FALSE,
  DIALOG_BOOLEAN_TRUE,
  DIALOG_MAIN_KEY,
  DIALOG_NUMBER_PREFIX,
  DIALOG_NUMBER_REGEX,
  DIALOG_PROP_PREFIX_SEPARATOR,
} from '@common/services';

export function extractSpecificProps(
  dialogKey: string,
  queryParams: URLSearchParams
) {
  const propPrefix = `${dialogKey}${DIALOG_PROP_PREFIX_SEPARATOR}`;
  const queryParamsEntries = Array.from(queryParams.entries());

  return queryParamsEntries.reduce((acc, [key, value]) => {
    if (key?.includes(propPrefix)) {
      const realPropKey = key.replace(propPrefix, '');

      return { ...acc, [realPropKey]: parsePropValueWithCorrectType(value) };
    }

    return acc;
  }, {});
}

function parsePropValueWithCorrectType(value: string): BuildDialogUrlPropValue {
  if (value === DIALOG_BOOLEAN_TRUE) {
    return true;
  }

  if (value === DIALOG_BOOLEAN_FALSE) {
    return false;
  }

  if (DIALOG_NUMBER_REGEX.test(value)) {
    return Number(value.replace(DIALOG_NUMBER_PREFIX, ''));
  }

  return value;
}

export function cleanUpQueryParams(
  dialogKey: string,
  queryParams: URLSearchParams
) {
  removeDialogKeyFromQueryParams(dialogKey, queryParams);
  removeDialogPropsFromQueryParams(dialogKey, queryParams);
}

function removeDialogKeyFromQueryParams(
  dialogKey: string,
  queryParams: URLSearchParams
) {
  queryParams.delete(DIALOG_MAIN_KEY, dialogKey);
}

function removeDialogPropsFromQueryParams(
  dialogKey: string,
  queryParams: URLSearchParams
) {
  Array.from(queryParams.keys())
    .filter((key) => key.includes(dialogKey))
    .forEach((key) => queryParams.delete(key));
}

export function validateDialogKeys(keys: DialogsMapKeyType[]) {
  return keys.filter((key) => {
    if (DIALOGS_MAP_KEYS.includes(key)) {
      return true;
    }

    console.warn(
      `DialogsController: Invalid dialog key was provided. ("${key}") \n`
    );

    return false;
  });
}

export function mapPermissionsValues(
  currentMembership: DialogsCurrentMembershipType
) {
  return Object.keys(currentMembership).reduce((acc, key) => {
    if (key === 'id') {
      return acc;
    }

    const currentRecord =
      currentMembership[key as DialogsMembershipPermissionsKeysType];

    return {
      ...acc,
      [key]: currentRecord,
    };
  }, {} as DialogsMembershipPermissionsType);
}
